import type { PageLoad } from "./$types";

export const load: PageLoad = async () => {
  return {
    title: "GPU Glossary",
    ogTitle: "GPU Glossary",
    ogDescription: "A glossary of terms related to GPUs.",
    description: "A glossary of terms related to GPUs.",
    ogImageUrl: "https://modal.com/assets/gpu-glossary-og-1.png",
  };
};
